export { default as RemixIcon } from './RemixIcon';
export type { RemixIconProps } from './RemixIcon';
